(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["flavour-showcase"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector("[data-fs-root]");
    if (!root) return;

    var dataEl = root.querySelector("[data-fs-data]");
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!data || !data.length) return;

    var names = root.querySelectorAll("[data-fs-index]");
    var cans = root.querySelectorAll("[data-fs-can]");
    var garnishes = root.querySelectorAll("[data-fs-garnish]");
    var copyEl = root.querySelector("[data-fs-copy]");
    var taglineEl = root.querySelector("[data-fs-tagline]");
    var buttonEl = root.querySelector("[data-fs-button]");
    var shopBtn = root.querySelector("[data-fs-shop]");
    var cartWrap = root.querySelector("[data-fs-cart]");
    var countEl = root.querySelector("[data-fs-count]");
    var addBtn = root.querySelector("[data-fs-add]");
    var cartUrl = root.getAttribute("data-cart-url") || "/cart";

    var state = { index: 0, qty: 1, cartOpen: false };
    var st = null;
    var hasGsap = function () { return !!window.gsap; };

    function toggleByIndex(list, attr, active) {
      for (var i = 0; i < list.length; i++) {
        var match = list[i].getAttribute(attr) === String(active);
        list[i].hidden = !match;
      }
    }

    function render(animate) {
      var f = data[state.index];
      if (!f) return;

      if (f.bg) root.style.setProperty("--fs-bg", f.bg);
      if (f.bgImage) { root.style.setProperty("--fs-bg-image", "url(" + f.bgImage + ")"); }
      else { root.style.setProperty("--fs-bg-image", "none"); }
      if (f.text) root.style.setProperty("--fs-text", f.text);
      if (f.name) root.style.setProperty("--fs-name", f.name);
      if (f.muted) root.style.setProperty("--fs-muted", f.muted);
      if (f.btnText) root.style.setProperty("--fs-btn-text", f.btnText);

      toggleByIndex(cans, "data-fs-can", state.index);
      if (garnishes.length) toggleByIndex(garnishes, "data-fs-garnish", state.index);

      if (copyEl) copyEl.innerHTML = f.desc || "";
      if (taglineEl) taglineEl.textContent = f.tagline || "";
      if (buttonEl) {
        buttonEl.textContent = f.buttonText || "Shop now";
        buttonEl.setAttribute("href", f.url || "#");
        buttonEl.setAttribute("target", f.target || "_self");
        if (f.target === "_blank") { buttonEl.setAttribute("rel", "noopener"); }
        else { buttonEl.removeAttribute("rel"); }
      }

      for (var i = 0; i < names.length; i++) {
        names[i].setAttribute("aria-current", i === state.index ? "true" : "false");
      }

      if (shopBtn) shopBtn.hidden = state.cartOpen;
      if (cartWrap) cartWrap.hidden = !state.cartOpen;
      if (countEl) countEl.textContent = state.qty;
      if (addBtn) addBtn.disabled = f.available === false || !f.variantId;

      if (animate && hasGsap() && !reduce) {
        var activeCan = root.querySelector('[data-fs-can="' + state.index + '"]');
        var content = root.querySelector("[data-fs-copy]");
        if (activeCan) {
          window.gsap.fromTo(activeCan,
            { scale: 0.9, opacity: 0, y: 24 },
            { scale: 1, opacity: 1, y: 0, duration: 0.5, ease: "back.out(1.2)" });
        }
        if (content) {
          window.gsap.fromTo(content.parentNode,
            { x: 30, opacity: 0 },
            { x: 0, opacity: 1, duration: 0.45, delay: 0.1, ease: "power3.out" });
        }
      }
    }

    function addToCart() {
      var f = data[state.index];
      if (!f || !f.variantId) return;
      if (addBtn) addBtn.disabled = true;
      fetch(cartUrl.replace(/\/$/, "") + "/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({ id: f.variantId, quantity: state.qty })
      })
        .then(function (r) { return r.json(); })
        .then(function () { window.location = cartUrl; })
        .catch(function () { if (addBtn) addBtn.disabled = false; });
    }

    root.addEventListener("click", function (e) {
      var t = e.target.closest("[data-fs-index], [data-fs-shop], [data-fs-minus], [data-fs-plus], [data-fs-add]");
      if (!t || !root.contains(t)) return;

      if (t.hasAttribute("data-fs-index")) {
        var i = parseInt(t.getAttribute("data-fs-index"), 10) || 0;
        if (i === state.index) return;
        if (st && data.length > 1) {
          var target = st.start + (i / (data.length - 1)) * (st.end - st.start);
          window.scrollTo({ top: target, behavior: "smooth" });
        } else {
          state.index = i;
          state.qty = 1;
          state.cartOpen = false;
          render(true);
        }
      } else if (t.hasAttribute("data-fs-shop")) {
        var f = data[state.index];
        if (!f || !f.variantId) return;
        e.preventDefault();
        state.cartOpen = true;
        render(false);
      } else if (t.hasAttribute("data-fs-minus")) {
        state.qty = Math.max(1, state.qty - 1);
        render(false);
      } else if (t.hasAttribute("data-fs-plus")) {
        state.qty += 1;
        render(false);
      } else if (t.hasAttribute("data-fs-add")) {
        addToCart();
      }
    });

    render(false);

    function setupScroll() {
      window.gsap.registerPlugin(window.ScrollTrigger);

      st = window.ScrollTrigger.create({
        trigger: root,
        start: "top top",
        end: function () { return "+=" + window.innerHeight * (N - 1); },
        pin: true,
        pinSpacing: true,
        snap: { snapTo: 1 / (N - 1), duration: 0.3, ease: "power1.inOut" },
        onUpdate: function (self) {
          var idx = Math.round(self.progress * (N - 1));
          if (idx === state.index) return;
          state.index = idx;
          state.qty = 1;
          state.cartOpen = false;
          render(true);
        }
      });
    }

    var N = data.length;
    var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (N > 1 && !reduce) {
      var tries = 0;
      (function waitForGsap() {
        if (window.gsap && window.ScrollTrigger) { setupScroll(); return; }
        if (tries++ > 100) return;
        setTimeout(waitForGsap, 100);
      })();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var header = document.querySelector("[data-header]");
    if (!header) return;

    var toggle = header.querySelector("[data-header-toggle]");
    var nav = document.getElementById("header-nav");
    if (toggle && nav) {
      toggle.addEventListener("click", function () {
        var open = header.classList.toggle("header--nav-open");
        toggle.setAttribute("aria-expanded", open ? "true" : "false");
      });
    }

    var bar = header.querySelector("[data-header-bar]");
    var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (bar && window.gsap && !reduce) {
      window.gsap.from(bar, { y: -24, opacity: 0, duration: 0.6, ease: "power3.out" });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-cart-root]');
    if (!root) return;

    var sectionId = root.getAttribute('data-section-id');
    var STORAGE_KEY = 'cart_applied_coupon';
    var busy = false;

    function cartUrl(path) {
      var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      return base.replace(/\/$/, '') + path;
    }

    function render(html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var next = doc.querySelector('[data-cart-root]');
      if (next) root.innerHTML = next.innerHTML;
    }

    function updateCount(count) {
      var nodes = document.querySelectorAll('[data-cart-count]');
      for (var i = 0; i < nodes.length; i++) nodes[i].textContent = count;
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { item_count: count } }));
    }

    function prefersReducedMotion() {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function animateRemove(card) {
      return new Promise(function (resolve) {
        if (!card || prefersReducedMotion()) {
          resolve();
          return;
        }

        if (window.gsap) {
          card.style.transition = 'none';
          window.gsap.to(card, {
            height: 0,
            paddingTop: 0,
            paddingBottom: 0,
            opacity: 0,
            x: 24,
            duration: 0.32,
            ease: 'power2.inOut',
            onComplete: resolve,
          });
          return;
        }

        card.style.height = card.offsetHeight + 'px';
        void card.offsetHeight;
        card.classList.add('is-removing');
        card.style.height = '0px';
        card.style.paddingTop = '0px';
        card.style.paddingBottom = '0px';

        var done = false;
        function finish() {
          if (done) return;
          done = true;
          resolve();
        }
        card.addEventListener('transitionend', function (event) {
          if (event.propertyName === 'height') finish();
        });
        setTimeout(finish, 400);
      });
    }

    function changeLine(line, quantity, card) {
      if (busy) return;
      busy = true;
      root.setAttribute('aria-busy', 'true');

      var animating = card && parseInt(quantity, 10) === 0 && !prefersReducedMotion();

      var req = fetch(cartUrl('/cart/change.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          id: line,
          quantity: parseInt(quantity, 10),
          sections: sectionId,
          sections_url: window.location.pathname,
        }),
      }).then(function (response) {
        return response.json();
      });

      var animation = animating ? animateRemove(card) : Promise.resolve();

      Promise.all([req, animation])
        .then(function (results) {
          var state = results[0];
          if (state && state.sections && state.sections[sectionId]) {
            render(state.sections[sectionId]);
          }
          if (state && typeof state.item_count === 'number') {
            updateCount(state.item_count);
          }
        })
        .catch(function () {
          window.location.reload();
        })
        .then(function () {
          busy = false;
          root.setAttribute('aria-busy', 'false');
        });
    }

    root.addEventListener('click', function (event) {
      var trigger = event.target.closest && event.target.closest('[data-cart-change]');
      if (!trigger || !root.contains(trigger)) return;
      event.preventDefault();
      var card = trigger.closest('.cart__card');
      changeLine(trigger.getAttribute('data-line'), trigger.getAttribute('data-quantity'), card);
    });

    root.addEventListener('click', function (event) {
      if (!event.target.closest || !event.target.closest('[data-cart-coupon-open]')) return;
      event.preventDefault();
      var coupon = root.querySelector('.cart__coupon');
      if (!coupon) return;
      coupon.open = true;
      coupon.scrollIntoView({ behavior: 'smooth', block: 'center' });
      var input = root.querySelector('#cart-coupon-input');
      if (input)
        setTimeout(function () {
          input.focus();
        }, 250);
    });

    function showCouponNote() {
      var note = root.querySelector('#cart-coupon-note');
      var coupon = root.querySelector('.cart__coupon');
      var applied = '';
      try {
        applied = sessionStorage.getItem(STORAGE_KEY) || '';
      } catch (e) {}
      if (note && applied) {
        note.textContent = note.getAttribute('data-applied-text');
        note.hidden = false;
        if (coupon) coupon.open = true;
        try {
          sessionStorage.removeItem(STORAGE_KEY);
        } catch (e) {}
      }
    }
    showCouponNote();

    root.addEventListener('submit', function (event) {
      var form = event.target.closest && event.target.closest('#cart-coupon-form');
      if (!form) return;
      event.preventDefault();
      var code = (form.coupon.value || '').trim();
      if (!code) return;
      try {
        sessionStorage.setItem(STORAGE_KEY, code);
      } catch (e) {}
      window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/cart';
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marquee"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var roots = Array.prototype.slice.call(document.querySelectorAll("[data-ticker]"));
    if (!roots.length) return;

    var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce) return;

    function setup(root) {
      if (root.dataset.tickerReady) return;
      var track = root.querySelector("[data-ticker-track]");
      var firstSet = root.querySelector(".marquee__set");
      if (!track || !firstSet) return;
      root.dataset.tickerReady = "1";

      var pps = parseFloat(root.getAttribute("data-speed"));
      if (isNaN(pps) || pps <= 0) pps = 100;

      function setWidth() { return firstSet.getBoundingClientRect().width; }

      var tween = window.gsap.to(track, {
        xPercent: -50,
        ease: "none",
        duration: setWidth() / pps,
        repeat: -1
      });

      var rt;
      window.addEventListener("resize", function () {
        clearTimeout(rt);
        rt = setTimeout(function () { tween.duration(setWidth() / pps); }, 150);
      });

      root.addEventListener("mouseenter", function () { tween.pause(); });
      root.addEventListener("mouseleave", function () { tween.play(); });
      if (window.fonts || (document.fonts && document.fonts.ready)) {
        document.fonts.ready.then(function () { tween.duration(setWidth() / pps); });
      }
    }

    var tries = 0;
    (function waitForGsap() {
      if (window.gsap) { roots.forEach(setup); return; }
      if (tries++ > 100) return;
      setTimeout(waitForGsap, 100);
    })();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pick-pack"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-pp-root]');
    if (!root) return;

    var dataEl = root.querySelector('[data-pp-data]');
    var data;
    try {
      data = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    if (!data.flavours || !data.flavours.length) return;

    var cartUrl = root.getAttribute('data-cart-url') || '/cart';
    var mediaEl = root.querySelector('[data-pp-media]');
    var mediaImgs = root.querySelectorAll('[data-pp-media] .pick-pack__media-img');
    var priceEl = root.querySelector('[data-pp-price]');
    var variantInput = root.querySelector('[data-pp-variant-id]');
    var qtyInput = root.querySelector('[data-pp-quantity]');
    var countEl = root.querySelector('[data-pp-count]');
    var addBtn = root.querySelector('[data-pp-add]');
    var swatchesWrap = root.querySelector('[data-pp-swatches]');
    var card = root.querySelector('[data-pp-card]');
    var assortedLabel = root.querySelector('[data-pp-assorted-label]');
    var qtyLabel = root.querySelector('[data-pp-qty-label]');
    var form = root.querySelector('[data-pp-form]');

    var state = { mode: 'flavours', flavour: 0, pack: null, qty: 1 };

    function flavourVariant(f) {
      if (!f) return null;
      var v = f.variants.filter(function (x) {
        return x.pack === state.pack;
      })[0];
      return v || f.variants[0];
    }
    function currentVariant() {
      return flavourVariant(data.flavours[state.flavour]);
    }
    function assortedVariant() {
      if (!data.assorted || !data.assorted.variants.length) return null;
      return flavourVariant(data.assorted);
    }
    function assortedItems() {
      var items = [];
      for (var i = 0; i < data.flavours.length; i++) {
        var v = flavourVariant(data.flavours[i]);
        if (v) items.push({ id: v.id, quantity: state.qty });
      }
      return items;
    }

    function render() {
      var cv = currentVariant();

      if (variantInput && cv) variantInput.value = cv.id;

      if (mediaEl) {
        var bg, bgImg;
        if (state.mode === 'assorted') {
          bg = (data.assorted && data.assorted.background) || data.mediaBackground;
          bgImg = data.assorted && data.assorted.backgroundImage;
        } else {
          var f = data.flavours[state.flavour];
          bg = (f && f.background) || data.mediaBackground;
          bgImg = f && f.backgroundImage;
        }
        mediaEl.style.backgroundColor = bg || '';
        mediaEl.style.backgroundImage = bgImg ? 'url("' + bgImg + '")' : 'none';
      }

      var av = assortedVariant();
      if (priceEl) {
        if (state.mode === 'assorted') {
          if (av) {
            priceEl.textContent = av.price;
          } else if (data.assortedTotals && data.assortedTotals[state.pack]) {
            priceEl.textContent = data.assortedTotals[state.pack];
          }
        } else if (cv) {
          priceEl.textContent = cv.price;
        }
      }

      if (addBtn) {
        if (state.mode === 'assorted') {
          addBtn.disabled = av ? av.available === false : data.flavours.length === 0;
        } else {
          addBtn.disabled = cv ? cv.available === false : true;
        }
      }

      if (mediaImgs.length) {
        var wantAssorted = state.mode === 'assorted';
        var variantId = cv ? String(cv.id) : null;
        var assortedVariantId = av ? String(av.id) : null;
        var shown = false;
        for (var i = 0; i < mediaImgs.length; i++) {
          var img = mediaImgs[i];
          var match;
          if (wantAssorted) {
            match = assortedVariantId
              ? img.getAttribute('data-pp-media-assorted-variant') === assortedVariantId
              : img.hasAttribute('data-pp-media-assorted');
          } else {
            match = variantId && img.getAttribute('data-pp-media-variant') === variantId;
          }
          img.hidden = !match;
          if (match) shown = true;
        }
        if (!shown && wantAssorted && assortedVariantId) {
          for (var k = 0; k < mediaImgs.length; k++) {
            if (mediaImgs[k].hasAttribute('data-pp-media-assorted')) {
              mediaImgs[k].hidden = false;
              shown = true;
              break;
            }
          }
        }
        if (!shown && !wantAssorted) {
          for (var j = 0; j < mediaImgs.length; j++) {
            if (mediaImgs[j].getAttribute('data-pp-media-flavour') === String(state.flavour)) {
              mediaImgs[j].hidden = false;
              shown = true;
              break;
            }
          }
        }
        if (!shown) mediaImgs[0].hidden = false;
      }

      root.querySelectorAll('[data-pp-pack]').forEach(function (b) {
        b.setAttribute('aria-checked', b.getAttribute('data-pp-pack') === state.pack ? 'true' : 'false');
      });
      root.querySelectorAll('[data-pp-mode]').forEach(function (b) {
        b.setAttribute('aria-pressed', b.getAttribute('data-pp-mode') === state.mode ? 'true' : 'false');
      });
      root.querySelectorAll('[data-pp-seat]').forEach(function (seat) {
        seat.classList.toggle('is-cream', seat.getAttribute('data-pp-seat') === state.mode);
      });
      if (card) card.classList.toggle('is-assorted', state.mode === 'assorted');
      root.querySelectorAll('[data-pp-flavour]').forEach(function (b) {
        b.setAttribute(
          'aria-pressed',
          parseInt(b.getAttribute('data-pp-flavour'), 10) === state.flavour ? 'true' : 'false'
        );
      });
      if (swatchesWrap) swatchesWrap.hidden = state.mode === 'assorted';
      if (assortedLabel) assortedLabel.hidden = state.mode !== 'assorted';
      if (qtyLabel) qtyLabel.textContent = state.qty;
      if (countEl) countEl.textContent = state.qty;
      if (qtyInput) qtyInput.value = state.qty;
    }

    state.pack = (data.flavours[0].variants[0] || {}).pack || null;

    root.addEventListener('click', function (e) {
      var t = e.target.closest('[data-pp-mode], [data-pp-pack], [data-pp-flavour], [data-pp-plus], [data-pp-minus]');
      if (!t || !root.contains(t)) return;

      if (t.hasAttribute('data-pp-mode')) {
        state.mode = t.getAttribute('data-pp-mode');
      } else if (t.hasAttribute('data-pp-pack')) {
        state.pack = t.getAttribute('data-pp-pack');
      } else if (t.hasAttribute('data-pp-flavour')) {
        state.flavour = parseInt(t.getAttribute('data-pp-flavour'), 10) || 0;
      } else if (t.hasAttribute('data-pp-plus')) {
        state.qty += 1;
      } else if (t.hasAttribute('data-pp-minus')) {
        state.qty = Math.max(1, state.qty - 1);
      }
      render();
    });

    if (form) {
      form.addEventListener('submit', function (e) {
        var body;
        if (state.mode === 'assorted') {
          var av = assortedVariant();
          if (av) {
            body = { id: av.id, quantity: state.qty };
          } else {
            var items = assortedItems();
            if (!items.length) return;
            body = { items: items };
          }
        } else {
          var v = currentVariant();
          if (!v) return;
          body = { id: v.id, quantity: state.qty };
        }
        e.preventDefault();
        if (addBtn) addBtn.disabled = true;
        fetch(cartUrl.replace(/\/$/, '') + '/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body),
        })
          .then(function (r) {
            return r.json();
          })
          .then(function () {
            window.location = cartUrl;
          })
          .catch(function () {
            form.submit();
          });
      });
    }

    render();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var roots = document.querySelectorAll("[data-video-section]");
    var mq = window.matchMedia("(min-width: 768px)");

    function activate(video) {
      if (!video) return;
      if (video.dataset.played) return;
      if (!video.dataset.loaded) {
        var sources = video.querySelectorAll("source[data-src]");
        for (var i = 0; i < sources.length; i++) {
          sources[i].setAttribute("src", sources[i].getAttribute("data-src"));
        }
        video.load();
        video.dataset.loaded = "1";
        video.addEventListener("ended", function () { video.dataset.played = "1"; });
      }
      var p = video.play();
      if (p && p.catch) { p.catch(function () {}); }
    }

    function applyTo(root) {
      var desktop = root.querySelector("[data-video-desktop]");
      var mobile = root.querySelector("[data-video-mobile]");
      if (mq.matches) {
        if (mobile) mobile.pause();
        activate(desktop);
      } else {
        if (desktop) desktop.pause();
        activate(mobile);
      }
    }

    function applyAll() {
      for (var i = 0; i < roots.length; i++) applyTo(roots[i]);
    }

    if (mq.addEventListener) { mq.addEventListener("change", applyAll); }
    else if (mq.addListener) { mq.addListener(applyAll); }
    applyAll();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["why-zero1"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var roots = Array.prototype.slice.call(document.querySelectorAll("[data-why-zero1]"));
    if (!roots.length) return;

    var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce) return;

    function enhanceRoot(root) {
      if (root.dataset.whyZero1Enhanced) return true;

      var viewport = root.querySelector("[data-why-zero1-viewport]");
      var steps = Array.prototype.slice.call(root.querySelectorAll(".why-zero1__step"));
      if (!viewport || steps.length < 2) {
        root.dataset.whyZero1Enhanced = "skip";
        return true;
      }
      if (!window.gsap || !window.ScrollTrigger) return false;
      try { window.gsap.registerPlugin(window.ScrollTrigger); } catch (e) {}

      root.dataset.whyZero1Enhanced = "1";
      root.classList.add("is-enhanced");
      root.style.height = steps.length * 100 + "vh";

      function setActive(i) {
        for (var s = 0; s < steps.length; s++) {
          steps[s].classList.toggle("is-active", s === i);
        }
        var bg = steps[i].getAttribute("data-bg");
        if (bg) viewport.style.backgroundColor = bg;
      }
      setActive(0);

      window.ScrollTrigger.create({
        trigger: root,
        start: "top top",
        end: "bottom bottom",
        onUpdate: function (self) {
          var i = Math.floor(self.progress * steps.length);
          if (i >= steps.length) i = steps.length - 1;
          if (i < 0) i = 0;
          setActive(i);
        }
      });
      return true;
    }

    function tryAll() {
      var allDone = true;
      for (var r = 0; r < roots.length; r++) {
        if (!enhanceRoot(roots[r])) allDone = false;
      }
      return allDone;
    }

    if (tryAll()) return;
    var tries = 0;
    var timer = setInterval(function () {
      if (tryAll() || ++tries > 50) clearInterval(timer);
    }, 100);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["whyzerome"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce) return;

    function setup($root) {
      if ($root.data("whyzeromeReady")) return;
      window.gsap.registerPlugin(window.ScrollTrigger);
      $root.data("whyzeromeReady", true);

      var $lockup = $root.find("[data-whyzerome-lockup]");
      var $cause = $root.find("[data-whyzerome-cause]");
      var $pink = $root.find("[data-whyzerome-pink]");
      var $track = $root.find("[data-whyzerome-track]");
      var $soda = $root.find("[data-whyzerome-soda]");
      var $too = $root.find("[data-whyzerome-too]");
      var $yellow = $root.find("[data-whyzerome-yellow]");
      var $green = $root.find("[data-whyzerome-green]");
      var $worked = $root.find("[data-whyzerome-worked]");
      var $sparkles = $root.find("[data-whyzerome-sparkles]");
      var $flavText = $root.find("[data-whyzerome-flavtext]");
      var bubbles = $root.find("[data-whyzerome-bubbles]")[0] || null;
      var video = $root.find("[data-whyzerome-video]")[0] || null;
      var fizz = video || bubbles;
      if (!$cause.length) return;

      var debug = $root.attr("data-debug") === "true";

      var bubbleThreshold = 1;
      function toggleVideo(p) {
        if (!video) return;
        if (p >= bubbleThreshold) {
          if (video.paused) { video.play().catch(function () {}); }
        } else if (!video.paused) {
          video.pause();
          video.currentTime = 0;
        }
      }

      var vh = parseFloat($root.attr("data-pin-vh"));
      if (isNaN(vh) || vh <= 0) vh = 2;

      $root.addClass("is-enhanced");
      window.gsap.set($pink[0], { yPercent: 100 });
      window.gsap.set($yellow[0], { yPercent: 100 });
      window.gsap.set($green[0], { yPercent: 100 });
      window.gsap.set($worked[0], { autoAlpha: 0, scale: 0.6 });
      window.gsap.set($sparkles[0], { autoAlpha: 0, scale: 0.6 });
      if (fizz) { window.gsap.set(fizz, { autoAlpha: 0, y: 20 }); }

      var track = $track[0], sodaEl = $soda[0], tooEl = $too[0];

      var TOO_MIN_SCALE = 0.7, TOO_MAX_SCALE = 1.5;
      var TOO_RAMP_MIN = 0.3;
      var TOO_LEAD = "T", TOO_FILL = "O", TOO_TAIL = "SWEET";
      var TOO_MIN_O = 3;
      var TOO_EDGE_SAFETY = 8;
      var TOO_RAMP_SPREAD = 0.5;
      var tooLetters = [];
      var tooStatic = [];
      var tooRampProxy = { p: 0 };

      function tooMakeLetter(ch) {
        var s = document.createElement("span");
        s.className = "too-sweet__letter";
        s.textContent = ch;
        return s;
      }
      function tooRender(n) {
        tooEl.textContent = "";
        tooLetters.length = 0;
        tooStatic.length = 0;
        var rampLen = 1 + n;
        for (var k = 0; k <= n; k++) {
          var glyph = tooMakeLetter(k === 0 ? TOO_LEAD : TOO_FILL);
          var t = rampLen > 1 ? k / (rampLen - 1) : 1;
          glyph.setAttribute("data-scale", (TOO_MIN_SCALE + (TOO_MAX_SCALE - TOO_MIN_SCALE) * t).toFixed(3));
          tooLetters.push(glyph);
          tooEl.appendChild(glyph);
        }
        tooEl.appendChild(document.createTextNode(" "));
        TOO_TAIL.split("").forEach(function (ch) {
          tooStatic.push(tooEl.appendChild(tooMakeLetter(ch)));
        });
      }
      function buildToo() {
        tooRender(2); var w2 = tooEl.offsetWidth;
        tooRender(1); var w1 = tooEl.offsetWidth;
        var wO = Math.max(1, w2 - w1);
        var wFixed = w1 - wO;
        var cs = window.getComputedStyle($pink[0]);
        var pad = (parseFloat(cs.paddingLeft) || 0) + (parseFloat(cs.paddingRight) || 0);
        var avail = $pink[0].clientWidth - pad - TOO_EDGE_SAFETY * 2;
        var n = Math.floor((avail - wFixed) / wO);
        if (!(n >= TOO_MIN_O)) n = TOO_MIN_O;
        tooRender(n);
      }
      function applyTooRamp(p) {
        var n = tooLetters.length, denom = (1 - TOO_RAMP_SPREAD) || 1;
        for (var i = 0; i < n; i++) {
          var el = tooLetters[i];
          var target = parseFloat(el.getAttribute("data-scale")) || TOO_MAX_SCALE;
          var start = n > 1 ? (i / (n - 1)) * TOO_RAMP_SPREAD : 0;
          var lp = (p - start) / denom; lp = lp < 0 ? 0 : lp > 1 ? 1 : lp;
          var e = 1 - (1 - lp) * (1 - lp);
          window.gsap.set(el, { scaleY: TOO_RAMP_MIN + (target - TOO_RAMP_MIN) * e });
        }
      }
      buildToo();

      function vw() { return $root[0].clientWidth; }
      function centreX(el) { return vw() / 2 - (el.offsetLeft + el.offsetWidth / 2); }
      function rightX(el) {
        var pad = parseFloat(window.getComputedStyle($pink[0]).paddingRight) || 0;
        return vw() - pad - (el.offsetLeft + el.offsetWidth);
      }
      window.gsap.set(track, { x: function () { return rightX(sodaEl); } });
      window.gsap.set(tooEl, { autoAlpha: 0, scaleY: 1 });
      window.gsap.set(tooStatic, { scaleY: TOO_MAX_SCALE });
      applyTooRamp(0);

      function shift() {
        var gap = parseFloat($lockup.css("column-gap") || $lockup.css("gap")) || 0;
        return ($cause[0].getBoundingClientRect().width + gap) / 2;
      }

      var tl = window.gsap.timeline({
        scrollTrigger: {
          id: "whyzerome",
          trigger: $root[0],
          start: "top top",
          end: "+=" + vh * 100 + "%",
          pin: true,
          pinSpacing: true,
          scrub: true,
          markers: debug,
          invalidateOnRefresh: true,
          refreshPriority: 1,
          onUpdate: function (self) { toggleVideo(self.progress); },
          onLeave: function () { if (video) video.pause(); },
          onLeaveBack: function () { if (video) video.pause(); }
        }
      });

      if (window.matchMedia && window.matchMedia("(max-width: 767px)").matches) {
        tl.fromTo($cause[0], { autoAlpha: 0, y: 24 }, { autoAlpha: 1, y: 0, ease: "none", duration: 1 }, 0);
      } else {
        tl.fromTo($lockup[0], { x: function () { return shift(); } }, { x: 0, ease: "none", duration: 1 }, 0);
        tl.fromTo($cause[0], { autoAlpha: 0, x: 40 }, { autoAlpha: 1, x: 0, ease: "none", duration: 1 }, 0);
      }

      tl.to({}, { duration: 0.3 });
      tl.to($pink[0], { yPercent: 0, ease: "power2.inOut", duration: 0.6 });

      tl.to({}, { duration: 1.0 });
      tl.to(track, { x: function () { return centreX(tooEl); }, ease: "power2.inOut", duration: 1.2 });
      tl.to(tooEl,  { autoAlpha: 1, ease: "power1.out", duration: 0.5 }, "<");
      tl.to(tooRampProxy, {
        p: 1, ease: "none", duration: 0.7,
        onUpdate: function () { applyTooRamp(tooRampProxy.p); }
      }, "<");
      tl.to(sodaEl, { autoAlpha: 0, ease: "power1.in",  duration: 0.5 }, "<0.7");

      tl.to({}, { duration: 0.8 });
      tl.to($yellow[0], { yPercent: 0, ease: "power2.inOut", duration: 1.0 });

      var beatStart = tl.duration() + 0.3;
      tl.to({}, { duration: 0.3 });
      tl.to($flavText[0], { autoAlpha: 0, ease: "power1.inOut", duration: 0.3 });
      if (fizz) {
        tl.to(fizz, { autoAlpha: 1, y: 0, ease: "power1.inOut", duration: 0.3 }, "<");
      }

      tl.to({}, { duration: 0.5 });
      tl.to($green[0], { yPercent: 0, ease: "power2.inOut", duration: 0.6 });

      tl.to({}, { duration: 0.6 });
      tl.to($worked[0], { autoAlpha: 1, scale: 1, ease: "back.out(1.6)", duration: 0.3 });
      tl.to($sparkles[0], { autoAlpha: 1, scale: 1, ease: "back.out(1.6)", duration: 0.3 }, "<");

      bubbleThreshold = beatStart / tl.duration();

      function refit() {
        buildToo();
        window.gsap.set(tooStatic, { scaleY: TOO_MAX_SCALE });
        applyTooRamp(tooRampProxy.p);
        if (window.ScrollTrigger) window.ScrollTrigger.refresh();
      }
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(refit);
      var tooResizeTimer;
      window.jQuery(window).on("resize.whyzerome orientationchange.whyzerome", function () {
        clearTimeout(tooResizeTimer);
        tooResizeTimer = setTimeout(refit, 150);
      });
    }

    function refresh() {
      if (window.ScrollTrigger) window.ScrollTrigger.refresh();
    }

    var tries = 0;
    (function waitForDeps() {
      if (window.jQuery && window.gsap && window.ScrollTrigger) {
        var $ = window.jQuery;
        var $roots = $("[data-whyzerome]");
        if (!$roots.length) return;
        $roots.each(function () { setup($(this)); });
        $(window).on("load", refresh);
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(refresh);
        return;
      }
      if (tries++ > 100) return;
      setTimeout(waitForDeps, 100);
    })();
  })();

  } catch(e) { console.error(e); }
})();
})();
